import React from 'react'
import PropTypes from 'prop-types'

const PaymentTypeSelector = props => {
  return (
    <div className='payment-type-selector'>
      {props.onManualCard &&
        <div className='payment-type-selector__item' onClick={props.onManualCard}>
          <div className='payment-type-selector__image'><img src='/shop/manual.png'/></div>
          <span className='payment-type-selector__title'>Manual Input</span>
        </div>
      }
      {props.onCash &&
        <div className='payment-type-selector__item' onClick={props.onCash}>
          <div className='payment-type-selector__image'><img src='/shop/green-cash.png'/></div>
          <span className='payment-type-selector__title payment-type-selector__title--cash'>Cash</span>
        </div>
      }
      {props.showTouchless &&
        <div className='payment-type-selector__item' onClick={props.onTouchless}>
          <div className='payment-type-selector__image'><img src='/shop/touchless.png' /></div>
          <span className='payment-type-selector__title payment-type-selector__title--touchless'>Touchless</span>
        </div>
      }
      {props.showTerminal &&
        <div 
          className={'payment-type-selector__item' + (props.terminalLoading ? ' loading' : '')}
          onClick={() => !props.terminalLoading && props.onBBPOSTerminal()}
        >
          { props.terminalLoading && <div className='animated-spinner'></div> }
          <div className='payment-type-selector__image'><img src='/shop/terminal.png'/></div>
          <span className='payment-type-selector__title payment-type-selector__title--terminal'>BBPOS Terminal</span>
        </div>
      }
      {props.showM2 &&
        <div 
          className={'payment-type-selector__item' + (props.m2Connected ? '' : ' loading')}
          onClick={() => props.m2Connected && props.onM2Terminal()}
        >
          <div className='payment-type-selector__image'><img src='/shop/nfc.png'/></div>
          <span className='payment-type-selector__title payment-type-selector__title--terminal'>M2 Terminal</span>
        </div>
      }
    </div>
  )
}

PaymentTypeSelector.propTypes = {
  showTouchless: PropTypes.bool,
  showTerminal: PropTypes.bool,
  showM2: PropTypes.bool,
  terminalLoading: PropTypes.bool,
  m2Connected: PropTypes.bool,
  onManualCard: PropTypes.func,
  onCash: PropTypes.func,
  onTouchless: PropTypes.func,
  onBBPOSTerminal: PropTypes.func,
  onM2Terminal: PropTypes.func
}

export default PaymentTypeSelector
